import { sensitivity, typeLabel } from '../labels/labels';
import { Icon } from './Icon';

// Status colours (§6.3) are backgrounds with navy text, never text on white, and always carry
// words and an icon: colour is never the only signal.
const toneClass = {
  success: 'bg-status-success text-brand-prussian',
  neutral: 'bg-neutral-field text-brand-prussian',
  warning: 'bg-status-warning text-brand-prussian',
  error: 'border-2 border-status-error bg-white text-brand-prussian',
} as const;

export function SensitivityBadge({ level }: { level?: string | null }) {
  if (!level) return null;
  const info = sensitivity[level];
  const tone = info?.tone ?? 'neutral';
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 text-small font-bold ${toneClass[tone]}`}
      title={info?.help}
    >
      <Icon name={info?.careful ? 'lock' : 'information'} className="h-4 w-4" />
      {info?.label ?? level}
    </span>
  );
}

export function TypeTag({ type }: { type: string }) {
  return (
    <span className="inline-flex items-center gap-1 text-small text-neutral-muted">
      <Icon name={type.toLowerCase() === 'dataset' ? 'database' : 'fileText'} className="h-4 w-4 text-brand-magenta" />
      {typeLabel(type)}
    </span>
  );
}
